import React, { PureComponent } from 'react';
import T from 'prop-types';
// shapes
import inputStep from '../../../shapes/inputStep';
// components
import Input from '../../../components/Input/Input';
import Icon from '../../../components/Icon/Icon';
import FieldError from '../../../components/Form/FieldError';
// styles
import styles from './GoalInput.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

const initialVisible = 3;
const placeholders = {
  text: 'Please, type your goal',
  number: 'Please, type days amount',
  award: 'Please, type your award',
};

class GoalsInput extends PureComponent {
  handleChange = ({ value, id, goalId }) => {
    const { values, setFieldValue } = this.props;
    setFieldValue(goalId, { ...values[goalId], [id]: value });
  };

  addGoal = () => {
    const { setFieldValue, values } = this.props;
    const emptyGoalId = Object.keys(values).find(id => {
      const valueId = Object.keys(values[id])[0];
      return values[id][valueId] === null;
    });
    const valueIds = Object.keys(values[emptyGoalId]);

    setFieldValue(emptyGoalId, {
      [valueIds[0]]: '',
      [valueIds[1]]: null,
      [valueIds[2]]: '',
    });
  };

  deleteGoal = deletableId => {
    const { values, setValues } = this.props;
    const activeGoals = this.getActiveGoals();
    const newValues = { ...values };

    const deletableIndex = activeGoals.findIndex(
      ({ id }) => id === deletableId
    );

    activeGoals.forEach(({ id }, index) => {
      const nextGoal = activeGoals[index + 1];
      const goalIds = Object.keys(values[id]);

      if (index < deletableIndex) return;

      if (nextGoal) {
        const nextGoalIds = Object.keys(values[nextGoal.id]);
        return (newValues[id] = {
          [goalIds[0]]: values[nextGoal.id][nextGoalIds[0]],
          [goalIds[1]]: values[nextGoal.id][nextGoalIds[1]],
          [goalIds[2]]: values[nextGoal.id][nextGoalIds[2]],
        });
      }

      newValues[id] = {
        [goalIds[0]]: null,
        [goalIds[1]]: null,
        [goalIds[2]]: null,
      };
    });

    setValues(newValues);
  };

  getInitialActive = () => {
    const { values } = this.props;
    const goalsIds = Object.keys(values);
    return goalsIds.slice(0, initialVisible);
  };

  getActiveGoals = () => {
    const { data, values } = this.props;
    const { connected_questions } = data.content;
    const initialActive = this.getInitialActive();
    return connected_questions.filter(({ id }) => {
      const value = values[id][Object.keys(values[id])[0]];
      return initialActive.includes(`${id}`) || value !== null;
    });
  };

  getAddAbility = activeGoals => {
    const {
      values,
      data: { content },
    } = this.props;
    const isActiveFilled = !activeGoals.find(
      ({ id }) => !values[id][Object.keys(values[id])[0]]
    );

    return (
      isActiveFilled && content.connected_questions.length > activeGoals.length
    );
  };

  render() {
    const { values, errors } = this.props;
    const activeGoals = this.getActiveGoals();
    const initialActive = this.getInitialActive();
    const canAdd = this.getAddAbility(activeGoals);

    return (
      <div>
        {activeGoals.map(goal => {
          const goalId = goal.id;
          const isDeletable = !initialActive.includes(`${goalId}`);

          return (
            <div className={cn('goal-wrapper')} key={goal.id}>
              <div className={cn('container')}>
                {goal.questions.map(
                  ({ title: label, id, question_type, placeholder }) => {
                    const type =
                      question_type === 'integer' ? 'number' : 'text';
                    const placeholderType = label === 'Award' ? 'award' : type;
                    return (
                      <div
                        key={id}
                        className={cn('input-container', {
                          number: type === 'number',
                          award: label === 'Award',
                        })}
                      >
                        <label className={cn('label')} htmlFor={id}>
                          {label}
                        </label>
                        <Input
                          wrapperClassName={cn('input-wrapper')}
                          name={id}
                          placeholder={
                            placeholder || placeholders[placeholderType]
                          }
                          type={type}
                          value={values[goalId][id]}
                          invalid={!!(errors[goalId] && errors[goalId][id])}
                          onChange={e =>
                            this.handleChange({
                              value: e.target.value,
                              id,
                              goalId,
                            })
                          }
                        />
                        <FieldError
                          error={errors[goalId] && errors[goalId][id]}
                          touched={true}
                        />
                      </div>
                    );
                  }
                )}
              </div>
              {isDeletable && (
                <button
                  type="button"
                  className={cn('button')}
                  onClick={() => this.deleteGoal(goalId)}
                >
                  <Icon className={cn('remove-item-icon')} type="delete" />
                </button>
              )}
            </div>
          );
        })}
        {canAdd && (
          <button type="button" className={cn('button')} onClick={this.addGoal}>
            <Icon className={cn('add-item-icon')} type="add" />
            Add new
          </button>
        )}
      </div>
    );
  }
}

GoalsInput.propTypes = {
  data: inputStep,
  values: T.object.isRequired,
  setFieldValue: T.func.isRequired,
};
export default GoalsInput;



// WEBPACK FOOTER //
// ./src/containers/Module/components/GoalsInput.jsx